import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/sub-admin";

export const List = async (values) => axiosInstance(options).post(`${path}/list-roles`, values);
export const Add = async (values) => axiosInstance(options).post(`${path}/add-role`, values);
export const Edit = async (values) => axiosInstance(options).post(`${path}/edit-role`, values);
export const Delete = async (values) => axiosInstance(options).post(`${path}/delete-role`, values);
export const Details = async (id) => axiosInstance(options).post(`${path}/role-details`, { o_id: id });
export const PermissionsOptions = async () => axiosInstance(options).get(`${path}/permission-options`);
